import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const EditDeliveryModal = ({ show, onHide, delivery, onUpdate }) => {
    const [modalData, setModalData] = useState({ runs_scored: 0, is_wicket: false });

    useEffect(() => {
        if (delivery) {
            setModalData({
                runs_scored: delivery.runs_scored,
                is_wicket: delivery.is_wicket,
            });
        }
    }, [delivery]);
    
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setModalData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleSave = () => {
        onUpdate({ ...delivery, ...modalData });
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton><Modal.Title>Edit Delivery</Modal.Title></Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3"><Form.Label>Runs Scored</Form.Label><Form.Control type="number" name="runs_scored" value={modalData.runs_scored} onChange={handleInputChange} /></Form.Group>
                    <Form.Group className="mb-3"><Form.Check type="checkbox" name="is_wicket" label="Is it a Wicket?" checked={modalData.is_wicket} onChange={handleInputChange} /></Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer><Button variant="secondary" onClick={onHide}>Cancel</Button><Button variant="primary" onClick={handleSave}>Update Ball</Button></Modal.Footer>
        </Modal>
    );
};

export default EditDeliveryModal;
